/* Little Lebanese — guided personaliser (v2).
   Fields keep their v1 line-item property names and are tied to Horizon's product form via form="",
   so Horizon's own add-to-cart sends them. Steps (v6, 1 Nov 2026): child (name, boy/girl, optional Arabic name), dedication (+ optional photo on Book 1), review. Grandparents are always Teta and Jeddo (hidden fields, 20 Oct 2026). */
(function () {
  'use strict';
  var d = document, html = d.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  /* suggested Arabic spellings for common names (only offered, never forced) */
  var AR = { maya: 'مايا', layan: 'ليان', nour: 'نور', noor: 'نور', yara: 'يارا', karim: 'كريم', kareem: 'كريم', george: 'جورج', adam: 'آدم', ali: 'علي', omar: 'عمر', jad: 'جاد', rami: 'رامي', elias: 'إلياس', lara: 'لارا', lina: 'لينا', rita: 'ريتا', tala: 'تالا', joud: 'جود', sami: 'سامي', hadi: 'هادي', ziad: 'زياد', nadim: 'نديم', charbel: 'شربل', karl: 'كارل', mia: 'ميا', lea: 'ليا', sarah: 'سارة', sara: 'سارة', ryan: 'ريان', rayan: 'ريان', yasmine: 'ياسمين', yasmina: 'ياسمينا', zeina: 'زينة', celine: 'سيلين', jana: 'جنى', perla: 'بيرلا', michel: 'ميشال', elie: 'إيلي', tony: 'طوني', marc: 'مارك', nadine: 'نادين', hala: 'هلا', reem: 'ريم', dana: 'دانا', lynn: 'لين', ahmad: 'أحمد', ahmed: 'أحمد', mohamad: 'محمد', mohammad: 'محمد', mohammed: 'محمد', hassan: 'حسن', hussein: 'حسين', fatima: 'فاطمة', maria: 'ماريا', noah: 'نوح', sophia: 'صوفيا', sofia: 'صوفيا', layla: 'ليلى', leila: 'ليلى', aya: 'آية', kinda: 'كندا', yasmin: 'ياسمين', ralph: 'رالف', chris: 'كريس', anthony: 'أنطوني', joseph: 'جوزيف', joe: 'جو', jude: 'جود', ella: 'إيلا', emma: 'إيما', lucas: 'لوكاس', liam: 'ليام', zain: 'زين', zayn: 'زين' };

  $$('[data-ll-personalise]').forEach(function (dlg) {
    var root = dlg.closest('.ll-pz') || d;
    var form = d.getElementById(dlg.getAttribute('data-form'));
    var book = d.getElementById(dlg.getAttribute('data-book')), wbook = d.getElementById(dlg.getAttribute('data-wbook'));
    if (!form) { /* fallback if the theme's product form id differs */
      var sec = root.closest('.shopify-section') || d;
      form = sec.querySelector('form[action*="/cart/add"]') || d.querySelector('form[action*="/cart/add"]');
      if (form) {
        if (!form.getAttribute('id')) form.setAttribute('id', 'll-product-form');
        $$('[form]', dlg).forEach(function (f) { f.setAttribute('form', form.getAttribute('id')); });
      }
    }
    var fid = form && form.getAttribute('id'); /* not form.id: Horizon's form has an input named "id" */
    /* JS on: the personaliser owns the purchase. Hide Horizon's buy buttons + quantity (quantity stays 1). */
    if (form) { var bb = form.closest('.buy-buttons-block') || form.closest('product-form-component'); if (bb) bb.classList.add('ll-hide-buy'); }
    /* LL v6 2026-11-01: express checkout (Shop Pay / Apple Pay / Google Pay) on the review step, only after the child's details
       are filled in. The whole product form moves into the review step so the wallet button sends the same personalisation. */
    var xslot = $('[data-ll-express]', dlg);
    if (form && bb && xslot && bb.querySelector('.accelerated-checkout-block')) { xslot.appendChild(bb); bb.classList.remove('ll-hide-buy'); bb.classList.add('ll-express-bb'); xslot.hidden = false; }
    html.classList.add('ll-pz-on');

    var steps = $$('.ll-ws', dlg), N = steps.length, cur = 0;
    var nameI = $('[data-ll-live=name]', dlg), arI = $('[data-ll-live=arname]', dlg);
    var tetaI = $('[name="properties[Grandmother is called]"]', dlg), gpI = $('[name="properties[Grandfather is called]"]', dlg);
    var dedI = $('[name="properties[Dedication]"]', dlg), photo = $('[data-ll-photo]', dlg);
    var bNext = $('[data-ll-next]', dlg), bBack = $('[data-ll-back]', dlg), bBuy = $('[data-ll-buy-now]', dlg);
    var body = $('[data-ll-body]', dlg);

    function gender() { var g = $('input[name="properties[Boy or girl]"]:checked', dlg); return g ? g.value : ''; }
    function live() {
      if (!window.LLsetCover) return;
      var n = nameI.value, a = arI ? arI.value : '', g = gender() || 'girl';
      window.LLsetCover(book, n, a, g); window.LLsetCover(wbook, n, a, g);
      suggest();
    }
    function suggest() {
      var box = $('[data-ll-suggest]', dlg); if (!box) return;
      var s = AR[(nameI.value || '').trim().toLowerCase()];
      if (s && arI.value.trim() !== s) { $('[data-ll-suggest-txt]', box).textContent = s; box.hidden = false; } else box.hidden = true;
    }

    /* ---------- validation: quiet until the visitor tries to move on ---------- */
    function msgFor(f) {
      var v = f.validity;
      if (f === nameI) return v.valueMissing ? "Please add your child's first name." : 'Please use English letters only (up to 12).';
      if (f.type === 'radio') return 'Please choose boy or girl.';
      if (f === arI) return 'Please use Arabic letters only, or leave it blank.';
      if (f === photo) return f.validationMessage;
      return f.validationMessage;
    }
    function fieldBox(f) { return f.closest('.ll-f') || f.closest('.ll-drop'); }
    function setErr(f, m) {
      var box = fieldBox(f); if (!box) return;
      var e = $('[data-ll-err]', box); box.classList.toggle('is-bad', !!m);
      if (e) e.textContent = m || '';
      $$('input,textarea', box).forEach(function (i) { if (i.type !== 'file' || i === f) i.setAttribute('aria-invalid', m ? 'true' : 'false'); });
    }
    function checkStep(i, focus) {
      var bad = null;
      $$('[form]', steps[i]).forEach(function (f) {
        if (f.type === 'radio' && f !== $('input[name="' + f.name + '"]', steps[i])) return;
        var ok = f.checkValidity(); setErr(f, ok ? '' : msgFor(f)); if (!ok && !bad) bad = f;
      });
      if (bad && focus) { bad.focus({ preventScroll: true }); bad.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); }
      return !bad;
    }
    $$('[form]', dlg).forEach(function (f) {
      f.addEventListener('invalid', function (e) { e.preventDefault(); setErr(f, msgFor(f)); });
      f.addEventListener(f.type === 'radio' || f.type === 'file' ? 'change' : 'input', function () { if (fieldBox(f) && fieldBox(f).classList.contains('is-bad') && f.checkValidity()) setErr(f, ''); });
    });

    /* ---------- step navigation ---------- */
    function go(i, opt) {
      i = Math.max(0, Math.min(N - 1, i)); cur = i;
      steps.forEach(function (s, k) { s.hidden = k !== i; });
      dlg.setAttribute('data-step', i + 1);
      $$('.ll-wiz__bar li', dlg).forEach(function (li, k) { li.className = k < i ? 'is-done' : k === i ? 'is-on' : ''; });
      $('[data-ll-wsnum]', dlg).textContent = 'Step ' + (i + 1) + ' of ' + N;
      $('[data-ll-wsname]', dlg).textContent = steps[i].getAttribute('data-name');
      bBack.hidden = i === 0; bNext.hidden = i === N - 1; bBuy.hidden = i !== N - 1;
      if (i === N - 1) review();
      body.scrollTop = 0; var sh = $('.ll-wiz__shell', dlg); if (sh) sh.scrollTop = 0;
      if (!opt || opt.focus !== false) { var h = $('.ll-ws__h', steps[i]); h && h.focus({ preventScroll: true }); }
    }
    bNext.addEventListener('click', function () { if (checkStep(cur, true)) go(cur + 1); });
    bBack.addEventListener('click', function () { go(cur - 1); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('input[type=text]')) { e.preventDefault(); (cur === N - 1 ? bBuy : bNext).click(); }
    });

    /* ---------- review ---------- */
    function esc(s) { var t = d.createElement('span'); t.textContent = s; return t.innerHTML; }
    function review() {
      var rc = $('[data-ll-review-cover]', dlg);
      if (rc && wbook && !rc.firstChild) { /* phone: show the big cover inside the review step */ var c = wbook.cloneNode(true); c.removeAttribute('id'); c.classList.add('ll-book--review'); rc.appendChild(c); }
      if (rc && rc.firstChild && window.LLsetCover) window.LLsetCover(rc.firstChild, nameI.value, arI.value, gender() || 'girl');
      var file = photo && photo.files && photo.files[0];
      function sn(el, dflt) { var s = el && el.closest('.ll-ws'); return s ? steps.indexOf(s) + 1 : dflt; } /* LL 2026-10-12: edit links follow the real step order */
      var gR = $('input[name="properties[Boy or girl]"]', dlg);
      var rows = [
        ['Name', esc(nameI.value.trim()), sn(nameI, 1)], ['Boy or girl', esc(gender()), sn(gR, 1)],
        ['Name in Arabic', arI.value.trim() ? '<span lang="ar" dir="rtl">' + esc(arI.value.trim()) + '</span>' : '<i>We\'ll suggest a spelling in your preview</i>', sn(arI, 2)],
        ['Dedication', dedI.value.trim() ? '“' + esc(dedI.value.trim()) + '”' : '<i>None</i>', sn(dedI, 4)],
        ['Family photo', file ? esc(file.name) : '<i>We\'ll email you for it after you order</i>', sn(photo, 5)]
      ];
      $('[data-ll-summary]', dlg).innerHTML = rows.map(function (r) {
        return '<div><dt>' + r[0] + '</dt><dd>' + r[1] + '</dd><button type="button" class="ll-sum__edit" data-ll-edit="' + r[2] + '" aria-label="Edit ' + r[0] + '">Edit</button></div>';
      }).join('');
    }
    dlg.addEventListener('click', function (e) { var b = e.target.closest('[data-ll-edit]'); if (b) go(+b.getAttribute('data-ll-edit') - 1); });

    /* ---------- open / close ---------- */
    function open(at) {
      if (typeof dlg.showModal !== 'function') { dlg.setAttribute('open', ''); return; }
      if (!dlg.open) dlg.showModal();
      html.classList.add('ll-wiz-open');
      go(at || cur);
    }
    function close() { if (dlg.open) dlg.close(); }
    dlg.addEventListener('close', function () { html.classList.remove('ll-wiz-open'); if (location.hash === '#personalise') history.replaceState(null, '', location.pathname + location.search); });
    $$('[data-ll-close]', dlg).forEach(function (b) { b.addEventListener('click', close); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); }); /* backdrop click (desktop) */
    /* LL 2026-10-15: CTAs open the quick add (name + boy/girl) when the page has one; [data-ll-full] always opens this full personaliser */
    $$('[data-ll-open-wizard]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); if (window.LLquick && !b.hasAttribute('data-ll-full')) window.LLquick.open(); else open(); }); });
    var launchCover = $('.ll-launch__cover', root); if (launchCover) { launchCover.style.cursor = 'pointer'; launchCover.addEventListener('click', function () { open(); }); }

    /* ---------- field behaviour ---------- */
    var m = location.search.match(/[?&]name=([^&]+)/);
    if (m && !nameI.value) nameI.value = decodeURIComponent(m[1]).replace(/[^A-Za-z' \-]/g, '').slice(0, 12);
    var mg = location.search.match(/[?&]g=(Girl|Boy)\b/i); if (mg) { var rg = $('input[name="properties[Boy or girl]"][value="' + (mg[1].toLowerCase() === 'boy' ? 'Boy' : 'Girl') + '"]', dlg); if (rg && !gender()) rg.checked = true; } /* LL 2026-10-20 */
    nameI.addEventListener('input', function () { var v = nameI.value.replace(/[^A-Za-z' \-]/g, ''); if (v !== nameI.value) nameI.value = v; live(); });
    arI.addEventListener('input', function () { var v = arI.value.replace(/[^\u0600-\u06FF ]/g, ''); if (v !== arI.value) arI.value = v; live(); });
    $$('input[name="properties[Boy or girl]"]', dlg).forEach(function (r) { r.addEventListener('change', live); });
    var useS = $('[data-ll-use-suggest]', dlg);
    if (useS) useS.addEventListener('click', function () { arI.value = $('[data-ll-suggest-txt]', dlg).textContent; setErr(arI, ''); live(); arI.focus(); });
    $$('input[type=text],textarea', dlg).forEach(function (i) { i.addEventListener('change', function () { i.value = i.value.replace(/\s+/g, ' ').trim(); }); });
    $$('[data-ll-quick]', dlg).forEach(function (q) {
      var inp = d.getElementById(q.getAttribute('data-ll-quick'));
      function mark() { $$('button', q).forEach(function (b) { b.setAttribute('aria-pressed', b.textContent === inp.value.trim() ? 'true' : 'false'); }); }
      $$('button', q).forEach(function (b) { b.addEventListener('click', function () { inp.value = b.textContent; setErr(inp, ''); mark(); }); });
      inp.addEventListener('input', mark); mark();
    });
    var cnt = $('.ll-f__count span', dlg);
    function count() { if (cnt) cnt.textContent = dedI.value.length; }
    dedI.addEventListener('input', count);
    $$('[data-ll-ideas] [data-tpl]', dlg).forEach(function (b) {
      function fill(t) { return t.replace(/\{name\}/g, nameI.value.trim() || 'Maya').replace(/\{teta\}/g, tetaI.value.trim() || 'Teta'); }
      b.addEventListener('click', function () { dedI.value = fill(b.getAttribute('data-tpl')).slice(0, 250); count(); dedI.focus(); });
      d.addEventListener('ll:refresh-ideas', function () { b.textContent = fill(b.getAttribute('data-tpl')); });
    });
    /* refresh idea labels with the real names when step 4 is shown */
    bNext.addEventListener('click', function () { if (steps[cur] && steps[cur].contains(dedI)) d.dispatchEvent(new Event('ll:refresh-ideas')); }); /* LL 2026-10-12: by content, not index */

    /* photo: later (default) or upload now with an uncropped preview */
    var drop = $('[data-ll-drop]', dlg), pv = $('[data-ll-photo-preview]', dlg), dt = $('[data-ll-drop-txt]', dlg);
    function resetPhoto() { if (!photo) return; photo.value = ''; photo.setCustomValidity(''); setErr(photo, ''); pv.hidden = true; pv.removeAttribute('src'); dt.innerHTML = '<b>Choose a photo</b><small>Tap to pick from your phone or computer</small>'; }
    $$('[data-ll-photo-mode]', dlg).forEach(function (r) {
      r.addEventListener('change', function () { var now = r.value === 'now' && r.checked; drop.hidden = !now; if (!now) resetPhoto(); });
    });
    if (photo) photo.addEventListener('change', function () {
      var f = photo.files && photo.files[0], msg = '';
      if (f && f.size > 20 * 1024 * 1024) msg = 'This photo is over 20 MB. Please choose a smaller one.';
      else if (f && !/^image\/(jpeg|png|webp)$/.test(f.type)) msg = 'Please choose a JPG, PNG or WEBP photo.';
      photo.setCustomValidity(msg); setErr(photo, msg);
      if (f && !msg) { pv.src = URL.createObjectURL(f); pv.hidden = false; dt.innerHTML = '<b>' + esc(f.name) + '</b><small>Tap to choose a different photo</small>'; }
      else { pv.hidden = true; }
    });

    /* ---------- pre-order: submit Horizon's own form, then go to the cart ---------- */
    var waiting = false, timer;
    function done(ok, msg) {
      waiting = false; clearTimeout(timer); bBuy.disabled = false; bBuy.classList.remove('is-busy');
      $('[data-ll-buy-label]', dlg).textContent = bBuy.getAttribute('data-label');
      if (ok) { $('[data-ll-buy-label]', dlg).textContent = 'Added. Taking you to your cart…'; location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart'; }
      else $('[data-ll-submit-err]', dlg).textContent = msg || 'Sorry, something went wrong. Please try again.';
    }
    bBuy.setAttribute('data-label', $('[data-ll-buy-label]', dlg).textContent);
    bBuy.addEventListener('click', function () {
      $('[data-ll-submit-err]', dlg).textContent = '';
      for (var i = 0; i < N - 1; i++) { if (!checkStep(i, false)) { go(i); checkStep(i, true); return; } }
      if (!form) { done(false); return; }
      waiting = true; bBuy.disabled = true; bBuy.classList.add('is-busy');
      $('[data-ll-buy-label]', dlg).textContent = 'Adding your book…';
      timer = setTimeout(function () { if (waiting) done(false, 'This is taking longer than usual. Please check your connection and try again.'); }, 15000);
      var sub = form.querySelector('[type=submit]');
      if (form.requestSubmit) form.requestSubmit(sub || undefined); else (sub ? sub.click() : form.submit());
    });
    d.addEventListener('cart:update', function (e) { if (waiting) done(true); });
    d.addEventListener('cart:error', function (e) { if (waiting) done(false, (e.detail && (e.detail.message || (e.detail.data && e.detail.data.message))) || null); });

    /* safety net: if anything else submits the form, check the fields first */
    if (form) form.addEventListener('submit', function (e) {
      /* LL 2026-10-20: grandparent names are optional; blank = our defaults (Teta / Jeddo) */
      if (tetaI && !tetaI.value.trim()) tetaI.value = 'Teta'; if (gpI && !gpI.value.trim()) gpI.value = 'Jeddo';
      var fields = $$('[form="' + fid + '"]');
      for (var k = 0; k < fields.length; k++) {
        if (!fields[k].checkValidity()) {
          e.preventDefault(); e.stopImmediatePropagation();
          var st = fields[k].closest('.ll-ws'); open(st ? +st.getAttribute('data-step') - 1 : 0); checkStep(cur, true);
          if (waiting) { waiting = false; clearTimeout(timer); bBuy.disabled = false; bBuy.classList.remove('is-busy'); $('[data-ll-buy-label]', dlg).textContent = bBuy.getAttribute('data-label'); }
          return;
        }
      }
    }, true);

    live(); count(); go(0, { focus: false });
    if (/^#personalise/.test(location.hash) || /[?&](name|personalise)=/.test(location.search)) setTimeout(function () { /* LL 2026-10-15: #personalise-all / ?personalise=all = full form */
      if (window.LLquick && !/^#personalise-all/.test(location.hash) && !/[?&]personalise=all/.test(location.search)) window.LLquick.open(); else open(); }, 150);
  });

  /* sticky bar on product: opens the personaliser (handled above via [data-ll-open-wizard]) */
})();
